import { FirebaseDocRefType } from 'firebase/index'
import { StoreType } from 'types/store'

const fetchShopRefOfStore = (storeRef: FirebaseDocRefType): Promise<FirebaseDocRefType | undefined> => {
  return storeRef.get().then((snapshot) => {
    const data = snapshot.data() as StoreType
    if (!data.shop_ref) return undefined
    return data.shop_ref
  })
}

export default fetchShopRefOfStore
